import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import ShortcutBar from "components/ShortcutBar";
import AppBreadcrumbs from "components/AppBreadcrumbs";
import IDefaultTemplate from "./type";
import { useAppSelector } from "store/hooks/useAppSelector";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "config/routes";
import { useAppDispatch } from "store/hooks/useAppDispatch";
import { removeUser } from "store/slices/auth";
import USER_ROLES from "pages/PageRoot/constants";
import { useLogOutMutation } from "store/api";
import styles from "./DefaultTemplate.styled";

const DefaultTemplate: React.FC<IDefaultTemplate> = ({ children }) => {
  const { login: user, role } = useAppSelector((state) => state.auth);
  const [logOut] = useLogOutMutation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const userRole = role === USER_ROLES.ADMIN ? "Адміністратор" : "Оператор";

  const handleLogOut = () => {
    logOut();
    dispatch(removeUser());
    navigate(routes.signin.root);
  };

  return (
    <>
      <Box sx={styles.headerWrap}>
        <Box sx={styles.leftSide}>
          <Link to={routes.home}>
            <Box sx={styles.logo} />
          </Link>
          {location.pathname !== routes.home && (
            <>
              <Divider sx={styles.divider} orientation="vertical" />
              <Box sx={styles.shortcutWrap}>
                <ShortcutBar />
              </Box>
            </>
          )}
        </Box>
        <Box sx={styles.userInfoWrap}>
          <Divider sx={styles.divider} orientation="vertical" />
          <Box sx={styles.userInfo}>
            <Typography sx={styles.user}>Користувач</Typography>
            <Box>
              <Typography sx={styles.userRole}>{`${user} -`}</Typography>
              <Typography component="span" sx={styles.userRole}>
                &nbsp;{userRole}
              </Typography>
            </Box>
          </Box>
          <Divider sx={styles.divider} orientation="vertical" />
          <Box sx={styles.logOutWrap} onClick={handleLogOut}>
            <Typography sx={styles.logOut}>Вийти</Typography>
            <LogoutIcon sx={styles.logOutIcon} />
          </Box>
        </Box>
      </Box>
      <Box sx={styles.childrenWrap}>
        <AppBreadcrumbs />
        {children}
      </Box>
    </>
  );
};

export default DefaultTemplate;
